import(/* webpackMode: "eager" */ "/home/jenkins/workspace/prod/deploy-frontend/src/app/[lang]/(editor)/error.tsx");
